import ReactGA from 'react-ga';
import ReactHtmlParser from 'react-html-parser';
const Entities = require('html-entities').AllHtmlEntities;
const entities = new Entities();

export function gaClick(retailer){
    var str = this.props.title + "-" + this.props.text + "-" + retailer;
    str = str.replace(/\s+/g, '-').toLowerCase();
    ReactGA.event({
        category: str,
        action: 'Clicked Link',
    });
}

export function decodeForDisplay(text){
    return ReactHtmlParser(entities.decode(text));
}


// WEBPACK FOOTER //
// ./src/helpers/functions.js